import overridableGetters from './overridableGetters.js';
import getterAlias from './getterAlias.js';

let getters = {
    burgerMenuAllowed(state, getters){
        return getters.enableSidebarCollapse;
    },
    burgerMenuAllowedAndClosed(state, getters){
        return state.burgerClosed && getters.enableSidebarCollapse;
    },
    burgerMenuClosed(state){
        return state.burgerClosed;
    },
    currentLang(state) {
        return state.langSelected;
    },
    getCorrectRelatedUrl: () => (object_related_url) => {
        return object_related_url;
    },
    getMenuActivated(state){
        return state.menuActivated;
    },
    getVerbose: (state, getters) => (field) => {
        try {
            return getters.appLangEntries[getters.currentLang][field];
        } catch (e) {
            return state.langDict[getters.currentLang][field];
        }
    },
    isCurrentUserAdmin(state, getters, rootState, rootGetters){
        return rootGetters.userIsAdmin;
    },
    isCurrentUserManager(state, getters, rootState, rootGetters){
        return rootGetters.userIsManager;
    },
    isCurrentUserSuperuser(state, getters, rootState, rootGetters){
        return rootGetters.userIsSuperUser;
    },
    isOnline(state){
        return state.status.online;
    },
    needUpdate(state){
        return state.status.update;
    },
    topBarIsRendered(state, getters){
        return !getters.isOnline || getters.needUpdate;
    },
};

for (var functionAlias in getterAlias) {
    if (getters[functionAlias] === undefined) {
        getters[functionAlias] = functionAlias;
    }
}

for(var functionName in overridableGetters){
    /* function called with parameters (state, getters, rootState, rootGetters) */
    // Copy variable with let to make it persistent
    let n = functionName;
    getters[n] = (s, g, rs, rg) => {
        if(rg.hasOwnProperty(n)) {
            return rg[n];
        }
        return overridableGetters[n](s, g, rs, rg);
    };
}

export default getters;



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/store/getters.js
// module id = null
// module chunks = 